import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = "BookingBarber - Réservation Beauté : Prothésiste Ongulaire, Microblading, Épilation Laser",
  description = "🌟 BookingBarber : La plateforme de réservation barbier la moins chère au monde ! Trouvez les meilleurs barbiers près de chez vous : corte cheveux homme, shave traditionnel, rasage, coiffage, barbe. Réservation en ligne 24/7.",
  keywords = "bookingbarber, plateforme réservation barbier, service moins cher monde, barbier, coiffeur homme, shave, corte cheveux, rasage, coiffage, barbe, réservation barbier en ligne, salon de barbier, barbier traditionnel, agenda automatisé barbier",
  canonicalUrl = "https://bookingbarber.com/",
  ogImage = "https://bookingbarber.com/Logos/logoFocus.png",
  ogType = "website",
  structuredData = null,
  noIndex = false,
  hreflang = null
}) => {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalUrl,
    "isPartOf": {
      "@type": "WebSite",
      "name": "BookingBarber",
      "url": "https://bookingbarber.com"
    },
    "about": {
      "@type": "Thing",
      "name": "Beauty Services Booking Platform"
    },
    "keywords": keywords
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Robots */}
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Hreflang if provided */}
      {hreflang && hreflang.map((lang, index) => (
        <link key={index} rel="alternate" hrefLang={lang.lang} href={lang.url} />
      ))}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="BookingBarber" />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="author" content="BookingBarber" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Language" content="fr" />
      <meta name="geo.region" content="FR" />
      <meta name="geo.placename" content="France" />
      
      {/* Structured Data */}
      {Array.isArray(structuredData) ? (
        structuredData.map((data, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))
      ) : (
        <script type="application/ld+json">
          {JSON.stringify(finalStructuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;